import { type VNode, Comment, type Slots } from "vue";

function isVNodeEmpty(vNodes: Array<VNode>) {
	return vNodes.every((vnode) => {
		if (vnode.type === Comment) {
			return true;
		}
		return false;
	});
}

export function useHasSlots(
	slots: Slots,
	slotNames: string[]
) {
	return slotNames.some((slotName) => {
		const slot = slots[slotName];
		if (!slot) {
			return false;
		}
		if (typeof slot === "function") {
			return !isVNodeEmpty(slot());
		}
		return true;
	});
}
